export function getReactiveUpdateUrl(host, channelsUrl) {
    if (!host || !channelsUrl) return null

    return `wss://${host}/ws/${channelsUrl}`
}


// WEBPACK FOOTER //
// ./helpers/reactivity.js